import GeoObjectAPI from '@/api/geoObject'

const state = {
  objects: {}
}

const getters = {
  getItems (state) {
    return (layerId, page, rowsPerPage) => state.objects[layerId]
  }
}
// actions
const actions = {
  async fetchAll (store, layerId) {
    const response = await GeoObjectAPI.getList(layerId)
    store.commit('setObjects', response)

    return response
  }
}

const mutations = {
  setObjects (state, data) {
    state.objects[data.layerId] = data.objects
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
